import { useEffect, useState } from "react";
import { TF } from "react-translator-component";
import CommentsModel from "./Models/commentModal/CommentsModel";
import CommentIcon from "@mui/icons-material/Comment";
import {
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import styled from "styled-components";

interface Props {
  post: any;
}

export default function PostCommentButton({
  post,
}: Props) {

  const [showCommentsModal, setShowCommentsModal] = useState<boolean>(false);
  const [commentCount, setCommentCount] = useState<number>(0);
  const [commentList, setCommentList] = useState<any[]>([]);

  useEffect(() => {
    if (!post) return
    setCommentCount(post.comments_count)
  }, [post]);

  const handleChangeComments = (comments: any[], count: number) => {
    setCommentList(comments)
    setCommentCount(count)
  }

  return (
    <>
      <Box>
        <IconButton
          onClick={() => setShowCommentsModal(true)}
          aria-label="thumbs"
        >
          <CommentIcon />
          <Typography>{TF("read_comments", commentCount)}</Typography>
        </IconButton>
      </Box>

      {showCommentsModal && (
        <ModalBackground onClick={() => setShowCommentsModal(true)}>
          <ModalContainer onClick={(e: any) => e.stopPropagation()}>
            <CommentsModel
              comments={commentList}
              post={post}
              closeModal={() => setShowCommentsModal(false)}
              onChange={(comments: any[], count: number) => handleChangeComments(comments, count)}
            />
          </ModalContainer>
        </ModalBackground>
      )}
    </>
  );
}

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end; /* Align items to the bottom */
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
  height: 85%;
  overflow-y: hidden;
  z-index: 9999;
`;
